import React from 'react';
import styled from 'styled-components';

export default function VideoEmbed({ url }) {
  const src = () => {
    let videoId = url.substring(url.lastIndexOf('/') + 1);
    if (url.includes('vimeo.com')) {
      return `https://player.vimeo.com/video/${videoId}`;
    }
    if (url.includes('youtube.com')) {
      videoId = url.substring(url.lastIndexOf('=') + 1);
    }
    return `https://www.youtube.com/embed/${videoId}`;
  };

  return (
    <IframeContainer>
      <iframe src={src()} frameBorder="0" allowFullScreen />
    </IframeContainer>
  );
}

const IframeContainer = styled.div`
  padding-bottom: 56.25%;
  position: relative;
  width: 100%;

  > iframe {
    height: 100%;
    width: 100%;
    position: absolute;
    top: 0;
    left: 0;
  }
`;
